<template>
<div class="function-bar-area">
  <ul class="function-bar" ref="bar">
    <li
      data-type="bar"
      :data-icon-name="bars[bar].name"
      :data-icon-type="bars[bar].iconType"
      :data-disabled="bars[bar].disabled"
      v-for="(bar,index) in Object.keys(bars)"
      :key="index"
      v-on:click.self="switchBar"
    >
      <ul
        class="option"
        :data-hide="isHide(bars[bar].name)"
      >
        <li
          v-for="(item,index) in bars[bar].items"
          :key="index"
          v-on:click.self="switchItems(bar, item)"
          :data-selected="bars[bar].selected === item"
        >
          {{ item }}
        </li>
      </ul>
    </li>
  </ul>
</div>

</template>

<script>
import stickyfill from 'stickyfilljs'

export const arrangeType = {
  newest: i18n.t('functionBar.newest'),
  hot: i18n.t('functionBar.hot')
}

export const makeBar = (iconType, name, items = [], selected = items[0], disabled = false) => ({
  iconType,
  name,
  items,
  selected,
  disabled
})

export default {
  data: () => ({
    which: ['bars', false],
    prewhich: 'bars', // 记录上一个switchBar选项
    bars: {
      category: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.category, i18n.t('functionBar.category')),
      arrange: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.arrange, i18n.t('functionBar.arrange'), [arrangeType.newest, arrangeType.hot]),
      merge: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.merge, i18n.t('functionBar.merge'))
    },
    all: i18n.t('functionBar.all'),
    hideBarTimeout: null,
    arrangeType: {
      newest: i18n.t('functionBar.newest'),
      hot: i18n.t('functionBar.hot')
    }
  }),
  props: { categories: Array },
  methods: {
    arraysEqual (arr1, arr2) {
      if (arr1.length !== arr2.length) { return false }
      for (let i = arr1.length; i--;) {
        if (arr1[i] !== arr2[i]) { return false }
      }
      return true
    },
    switchItems (bar, item) {
      if (this.bars[bar].selected === item) return
      switch (this.bars[bar].name) {
        case this.bars.category.name:
          this.$emit('changeCategory', item === this.all ? '' : item); break
        case this.bars.arrange.name:
          this.$emit('changeArrange', item); break
        default: break
      }
      this.bars[bar].selected = item
      this.hideBarTimeout = setTimeout(this.switchBar, 500)
    },
    switchBar ({ target } = {}) {
      clearTimeout(this.hideBarTimeout)
      if (target && target.getAttribute) {
        const which = target.getAttribute('data-icon-name')
        const isCurrent = this.which[0] === which
        const isCurrentShowed = this.which[1]
        this.which = [which, isCurrent ? !isCurrentShowed : true ]

        this.bars.merge.disabled = false

        if (which === this.bars.merge.name) {
          if (this.prewhich === i18n.t('functionBar.video')) {
            this.bars.merge.disabled = true
            return
          }
          this.$store.state.isShowMergePicMode = true
        } else if (this.bars.video && which === this.bars.video.name) {
          if (this.prewhich === i18n.t('functionBar.merge')) {
            this.$store.state.isShowMergePicMode = false
          }
          this.$emit('changeCategory', i18n.t('functionBar.video'))
          this.bars.merge.disabled = true
        } else if (which === this.bars.category.name && this.prewhich !== this.bars.category.name) {
          this.bars['category'].selected = this.all
          this.$emit('changeCategory', '')
        } else if (which === this.bars.arrange.name) {
          if (this.prewhich === i18n.t('functionBar.video')) {
            this.bars.merge.disabled = true
            return
          }
        }
        this.prewhich = which// 记录上一个switchBar选项
        //console.log(which)
      } else if (this.which[1] && this.which[0] !== this.bars.merge.name) {
        this.which = ['', false]
      }
    },
    isHide (which) {
      const isCurrent = this.which[0] === which
      const CurrentStatus = this.which[1]
      return !(isCurrent && CurrentStatus)
    },
    updateCategories () {
      let newCategories = [this.all].concat(this.categories)
      if (newCategories.indexOf(i18n.t('functionBar.video')) !== -1) {
        newCategories.splice(newCategories.indexOf(i18n.t('functionBar.video')), 1)
      }
      if (this.arraysEqual(this.bars.category.items, newCategories)) return
      this.bars.category = makeBar(i18n.getLocaleMessage('zh-cn').functionBar.category, i18n.t('functionBar.category'), newCategories)
    }
  },
  mounted () {
    this.bars = {
      category: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.category, i18n.t('functionBar.category')),
      arrange: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.arrange, i18n.t('functionBar.arrange'), [arrangeType.newest, arrangeType.hot]),
      merge: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.merge, i18n.t('functionBar.merge'))
    },
    window.addEventListener('scroll', this.switchBar)
    this.updateCategories()
    stickyfill.add(this.$refs.bar)
  },
  updated () {
    this.updateCategories()
  },
  // watch: {
  //   categories: function (val, oldVal) {
  //     this.updateCategories()
  //   },
  // },
  destroyed () {
    window.removeEventListener('scroll', this.switchBar)
  }
}
</script>
